import { Directory, RootDirectory } from "../../../../../domain/drawing";
import { FormatReference, FormatSet } from "../../../../../domain/format";

export class FormatSetTreeEditModel {
  constructor() {
    this.clear();
  }
  editingDirectory: RootDirectory<string, FormatSet>;
  selectedDirectory: Directory<string, FormatSet>;
  selectedFormatSet: FormatSet;
  selectedFormat: FormatReference;
  editFolderText: string;
  editFormatSetText: string;
  editFormatText: string;
  addFolderText: string;
  addFormatSetText: string;
  addDirectory: Directory<string, FormatSet>;
  addFormatSets: FormatSet[];
  addFormats: FormatReference[];
  deleteFolderFlag: boolean;
  deleteFormatSetFlag: boolean;
  deleteFormatFlag: boolean;
  updateCompletedDirectoryFlag: boolean;
  completedDirectory: RootDirectory<string, FormatSet>;

  clear(): void {
    this.editingDirectory = null;
    this.selectedDirectory = null;
    this.selectedFormatSet = null;
    this.selectedFormat = null;
    this.editFolderText = "";
    this.editFormatSetText = "";
    this.editFormatText = "";
    this.addFolderText = "";
    this.addFormatSetText = "";
    this.addDirectory = null;
    this.addFormatSets = null;
    this.addFormats = null;
    this.deleteFolderFlag = false;
    this.deleteFormatSetFlag = false;
    this.deleteFormatFlag = false;
    this.updateCompletedDirectoryFlag = false;
    this.completedDirectory = null;
  }
}
